import { IconButton, getTokensPropType, useThemeTokensCallback } from '@telus-uds/components-base';
import React from 'react';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const SideButton = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    isEnabled = true,
    onPress = () => {},
    onDoubleClick = () => {},
    accessibilityLabel = '',
    accessibilityDisabled = false,
    tokens = {},
    variant = {}
  } = _ref;
  const getTokens = useThemeTokensCallback('QuantitySelectorSideButton', tokens, variant);
  const getButtonTokens = _ref2 => {
    let {
      buttonState,
      disabled
    } = _ref2;
    const {
      borderRadius,
      borderTopLeftRadius,
      borderTopRightRadius,
      borderBottomLeftRadius,
      borderBottomRightRadius,
      ...rest
    } = getTokens({
      ...buttonState,
      disabled
    });
    return {
      ...rest,
      borderRadius,
      borderTopLeftRadius,
      borderTopRightRadius,
      borderBottomLeftRadius,
      borderBottomRightRadius,
      outerBorderRadius: borderRadius,
      outerBorderTopLeftRadius: borderTopLeftRadius,
      outerBorderTopRightRadius: borderTopRightRadius,
      outerBorderBottomLeftRadius: borderBottomLeftRadius,
      outerBorderBottomRightRadius: borderBottomRightRadius,
      outerBorderGap: 0,
      outerBorderWidth: 0
    };
  };
  return /*#__PURE__*/_jsx(IconButton, {
    tokens: buttonState => getButtonTokens({
      disabled: !isEnabled,
      buttonState
    }),
    onPress: onPress,
    onDoubleClick: onDoubleClick,
    accessibilityLabel: accessibilityLabel,
    accessibilityDisabled: accessibilityDisabled,
    ref: ref
  });
});
SideButton.displayName = 'QuantitySelectorSideButton';
SideButton.propTypes = {
  isEnabled: PropTypes.bool,
  onPress: PropTypes.func,
  onDoubleClick: PropTypes.func,
  accessibilityLabel: PropTypes.string,
  accessibilityDisabled: PropTypes.bool,
  tokens: getTokensPropType('QuantitySelectorSideButton'),
  variant: PropTypes.object
};
export default SideButton;